<template>
  <el-tag :type="updatedAt | connectDateTimeClassFilter">
    <strong>
      {{ updatedAt | connectDateTimeFilter }}
    </strong>
  </el-tag>
</template>
<script>
import dayjs from 'dayjs';
const reletiveTime = require('dayjs/plugin/relativeTime');
dayjs.extend(reletiveTime);
export default {
  filters: {
    connectDateTimeFilter(datetime) {
      dayjs.locale('zh-tw');
      let input_dayjs = dayjs(datetime);
      if (dayjs(datetime).isBefore(dayjs().subtract(1, 'days'))) {
        return dayjs(datetime).format('YYYY-MM-DD HH:mm:ss');
      } else {
        return input_dayjs.isValid() ? input_dayjs.fromNow() : '無紀錄';
      }
    },
    connectDateTimeClassFilter(datetime) {
      try {
        if (!dayjs(datetime).isValid()) {
          return 'warning';
        }
        if (dayjs(datetime).isBefore(dayjs().subtract(1, 'days'))) {
          return 'danger';
        } else {
          return 'success';
        }
      } catch (error) {
        return 'danger';
      }
    },
  },
  props: {
    updatedAt: {},
  },
};
</script>
